/*******************************************************************************
 * @ngdoc    object
 * @name     csm.books.data.BooksData.rws.type:Product
 * @constructor
 * @param {object=} item  Product info from server.
 * @description
 * Remote webstore product item info.
 *******************************************************************************/
/* @ngInject */ export function RunProduct(BooksData) {
  BooksData.rws.Product = function (product) {
    var rv = Object.assign(
      Object.create(BooksData.rws.Product.prototype),
      product || {}
    );
    rv.options = (rv.options || []).map(function (o) {
      return new BooksData.rws.Option(o);
    });
    rv.subProducts = (rv.subProducts || []).map(function (p) {
      return new BooksData.rws.Product(p);
    });
    return rv;
  };

  BooksData.rws.Product.prototype = {
    siteID: null, // Webstore organization site code.
    siteName: null, // Webstore organization site name.
    orderItemID: null, // Unique order item id from provider.
    depositCode: null, // Deposit bank account code (non-kit products only).
    revenueCode: null, // Revenue accound code (non-kit products only).
    studentID: null, // Student ID.
    productID: NaN, // Product identifier.
    name: null, // Short product descripton.
    price: NaN, // Product price.
    quantity: NaN, // Sales quantity.
    saleAmount: NaN, // Sale amount.
    salesTax: NaN, // Sales tax.
    serviceFee: NaN, // Service fee charged.
    totalAmount: NaN, // Total sale amount.
    options: [], // List of item options (non-kit products only).

    /*-------------------------*/
    /* Output Only properties. */
    /*-------------------------*/
    imageURL: null, // Image url.
    description: null, // Long product description.
    isDonation: false, // Is Donation flag.
    fixedPrice: false, // Fixed price flag.
    taxRate: NaN, // Sales tax rate as NaN    , 0=non-taxable.
    taxable: false, // Taxable flag
    subProducts: [], // List of products in kit (kit products only).

    /*-----------------------*/
    /* Debt Item Information */
    /*-----------------------*/
    referenceID: NaN, // Reference ID for Payments.
    amountOwed: NaN // Amount still remaining on item.
  };
}
